module.exports = __webpack_public_path__ + "static/media/0222_IMG_LES_MURS_P21_UNI_CRISTAL_CHEVRON.6f5bc1d4.webp";